import { Box, VStack } from '@skin-seoul/design-system';
import { type TaxonomyCategory } from '../utils/categoryUtils';
import CategoryTextItem from './CategoryTextItem';
interface SubcategoryItemProps {
  subcategory: TaxonomyCategory;
  isActive: boolean;
  routeBasedSubSubcategory: number | null;
  selectedSubSubcategory: number | undefined;
  onSubcategoryClick: (termId: number, name: string) => void;
  onSubSubcategoryClick: (termId: number, name: string) => void;
}
const SubcategoryItem = ({
  subcategory,
  isActive,
  routeBasedSubSubcategory,
  selectedSubSubcategory,
  onSubcategoryClick,
  onSubSubcategoryClick
}: SubcategoryItemProps) => {
  const hasSubSubCategories = subcategory.subCategories && subcategory.subCategories.length > 0;
  return <Box data-sentry-element="Box" data-sentry-component="SubcategoryItem" data-sentry-source-file="SubcategoryItem.tsx">
      <CategoryTextItem name={subcategory.name} isActive={isActive} onClick={() => onSubcategoryClick(subcategory.termId, subcategory.name)} data-sentry-element="CategoryTextItem" data-sentry-source-file="SubcategoryItem.tsx" />

      {hasSubSubCategories && <VStack align="stretch" gap={1} marginLeft={2} marginTop={1}>
          {subcategory.subCategories?.map((subSubCat: TaxonomyCategory) => {
        const isSubSubcategoryActive = routeBasedSubSubcategory === subSubCat.termId || selectedSubSubcategory === subSubCat.termId;
        return <CategoryTextItem key={subSubCat.termId} name={subSubCat.name} isActive={isSubSubcategoryActive} onClick={() => onSubSubcategoryClick(subSubCat.termId, subSubCat.name)} />;
      })}
        </VStack>}
    </Box>;
};
export default SubcategoryItem;